import i18n, { _loadAndSetLocaleAsync } from 'src/i18n'
import Model from 'src/models/Model'

export default async ({ app }) => {
  app.i18n = i18n.global

  app.use(i18n)

  await Model.context.ensureLoaded()
  const resolvedLocale = Model.context.currentLocale
  // Always call this, even if the resolvedLocale is the same as the current locale,
  // to ensure any the locale files are loaded.
  _loadAndSetLocaleAsync(resolvedLocale)
}
